import { jsx as _jsx, jsxs as _jsxs } from "@redneckz/uni-jsx/jsx-runtime";
/* eslint-disable max-lines, max-lines-per-function */
import { useEffect } from '@redneckz/uni-jsx/lib/hooks';
import { useForm } from '../../hooks/useForm.js';
import { DEFAULT_MONTHS } from '../../ui-kit/Calculator/calculatorConstants.js';
import { CalculatorLayout } from '../../ui-kit/Calculator/CalculatorLayout.js';
import { CalculatorStyle } from '../../ui-kit/Calculator/CalculatorStyle.js';
import { CalculatorValue } from '../../ui-kit/Calculator/CalculatorValue.js';
import { getDefaultParamsMin } from '../../ui-kit/Calculator/getDefaultParams.js';
import { getMoneyDefaultValue, getMonthsDefaultValue, } from '../../ui-kit/Calculator/getDefaultValues.js';
import { renderFootnote } from '../../ui-kit/Calculator/renderFootnote.js';
import { renderMonthsInput } from '../../ui-kit/Calculator/renderMonthsInput.js';
import { renderPaymentType } from '../../ui-kit/Calculator/renderPaymentType.js';
import { renderWantedSumInput } from '../../ui-kit/Calculator/renderWantedSumInput.js';
import { setDefaultParamsCalc } from '../../ui-kit/Calculator/setDefaultParamsCalc.js';
import { Checkbox } from '../../ui-kit/Checkbox/Checkbox.js';
import { renderButtonsSection } from '../../ui-kit/LinkButton/renderButtonsSection.js';
import { UniBlock } from '../../UniBlock/UniBlock.js';
import { clamp } from '../../utils/clamp.js';
import { style } from '../../utils/style.js';
import { getCreditCalculatorParams } from './getCreditCalculatorParams.js';
import { isDefaultParams } from './isDefaultParams.js';
const CREDIT_DEFAULT_SUM = 200000;
const MAP = {
    isSalaryClient: 'isSalaryClient',
    isStateEmployee: 'isStateEmployee',
    isPensionClient: 'isPensionClient',
    isInsurance: 'isInsurance',
    moneyValue: 'maxSum',
};
export const CalculatorCredit = UniBlock(({ className, title, calcSource, buttons, footnote, paramsViewSettings, defaultParams, ...rest }) => {
    const defaultParamsCals = getDefaultParamsMin(calcSource?.rateRows);
    const [userInputParams, { field }] = useForm({
        moneyValue: getMoneyDefaultValue(defaultParams, CREDIT_DEFAULT_SUM),
        monthsValue: getMonthsDefaultValue(defaultParams, DEFAULT_MONTHS),
        isAnnuity: Boolean(defaultParams?.isAnnuity),
        isInsurance: Boolean(defaultParams?.isEnableInsurance),
        isSalaryClient: Boolean(defaultParams?.isEnableSalaryClient),
        isPensionClient: Boolean(defaultParams?.isEnablePensionClient),
        isStateEmployee: Boolean(defaultParams?.isEnableStateEmployee),
    });
    const calcParams = getCreditCalculatorParams(userInputParams, calcSource, paramsViewSettings);
    const paymentTypeElement = renderPaymentType({
        title: 'Тип платежа',
        orientation: 'vertical',
        ...field('isAnnuity'),
    });
    const { onChange: setMoneyValue } = field('moneyValue');
    const { onChange: setMonthsValue } = field('monthsValue');
    useEffect(() => {
        setMoneyValue &&
            setMoneyValue(clamp(userInputParams.moneyValue, calcParams.minSum, calcParams.maxSum));
    }, [calcParams.minSum, calcParams.maxSum]);
    useEffect(() => {
        setMonthsValue &&
            setMonthsValue(clamp(userInputParams.monthsValue, calcParams.minMonths, calcParams.maxMonths));
    }, [calcParams.minMonths, calcParams.maxMonths]);
    useEffect(() => {
        if (!isDefaultParams(defaultParams) && defaultParamsCals) {
            setDefaultParamsCalc({
                field,
                defParams: defaultParamsCals,
                calcParams,
                map: MAP,
                monthsValue: 'minMonths',
            });
        }
    }, [calcSource, defaultParams]);
    return (_jsx(CalculatorLayout, { className: className, title: title, ...rest, children: _jsxs("section", { className: style(CalculatorStyle.wrapper, className), children: [_jsxs("div", { className: CalculatorStyle.input, children: [renderWantedSumInput({
                            title: 'Сумма кредита, ₽',
                            step: 500,
                            min: calcParams.minSum,
                            max: calcParams.maxSum,
                            ...field('moneyValue'),
                            value: calcParams.moneyValue,
                        }), renderMonthsInput({
                            title: 'Срок кредита, месяцев',
                            min: calcParams.minMonths,
                            max: calcParams.maxMonths,
                            ...field('monthsValue'),
                            value: calcParams.monthsValue,
                        }), renderCreditParamsForm({ ...calcParams, ...paramsViewSettings }, field), _jsx("div", { className: "sm:hidden", children: paymentTypeElement })] }), _jsxs("div", { className: style(CalculatorStyle.result, '@4xl:w-1/2'), children: [_jsx(CalculatorValue, { title: "\u041F\u043E\u043B\u043D\u0430\u044F \u0441\u0442\u043E\u0438\u043C\u043E\u0441\u0442\u044C \u043A\u0440\u0435\u0434\u0438\u0442\u0430", value: calcSource?.totalLoanCost }), _jsx(CalculatorValue, { title: "\u0421\u0442\u0430\u0432\u043A\u0430", value: calcParams?.rate, fractionDigits: 2, postfix: "%" }), _jsx(CalculatorValue, { title: "\u0415\u0436\u0435\u043C\u0435\u0441\u044F\u0447\u043D\u044B\u0439 \u043F\u043B\u0430\u0442\u0451\u0436", value: calcParams.monthlyPayment, postfix: "\u20BD" }), _jsx("div", { className: "hidden sm:block mb-lg", children: paymentTypeElement }), renderButtonsSection(buttons, { isVertical: true }), renderFootnote(footnote)] })] }) }));
});
const renderCreditParamsForm = (params, field) => (_jsxs("div", { className: "flex flex-col gap-y-2xl", children: [params.isShowSalaryClient ? (_jsx(Checkbox, { text: `Получаю зарплату на счёт\nв Россельхозбанке`, ...field('isSalaryClient'), value: params.isSalaryClient, className: "whitespace-pre-line sm:whitespace-normal" })) : null, params.isShowStateEmployee ? (_jsx(Checkbox, { text: "\u0420\u0430\u0431\u043E\u0442\u0430\u044E \u0432 \u0431\u044E\u0434\u0436\u0435\u0442\u043D\u043E\u0439 \u043E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0446\u0438\u0438", ...field('isStateEmployee'), value: params.isStateEmployee })) : null, params.isShowPensionClient ? (_jsx(Checkbox, { text: "\u041F\u043E\u043B\u0443\u0447\u0430\u044E \u043F\u0435\u043D\u0441\u0438\u044E \u043D\u0430 \u043A\u0430\u0440\u0442\u0443 \u0420\u043E\u0441\u0441\u0435\u043B\u044C\u0445\u043E\u0437\u0431\u0430\u043D\u043A\u0430", ...field('isPensionClient'), value: params.isPensionClient })) : null, params.isShowInsurance ? (_jsx(Checkbox, { text: "\u041A\u043E\u043C\u043F\u043B\u0435\u043A\u0441\u043D\u0430\u044F \u0441\u0442\u0440\u0430\u0445\u043E\u0432\u0430\u044F \u0437\u0430\u0449\u0438\u0442\u0430", ...field('isInsurance'), value: params.isInsurance })) : null] }));
//# sourceMappingURL=CalculatorCredit.js.map